export const transformationStats: { value: string; label: string }[] = [
  { value: '6 Volumes', label: 'U8 to U17, plus a full games and season-plan volume' },
  { value: '48 Training Blocks', label: 'sequenced, not random' },
  { value: '100%', label: 'ready to print, nothing to prepare' },
]
